export const lineType = [
  { label: '普通线', value: 1 },
  { label: '旅游线', value: 2 },
  { label: '校园线', value: 3 },
  { label: '接驳线', value: 4 },
  { label: '机场线', value: 5 }
]
export const state = [
  { label: '正常', value: 1 },
  { label: '下架', value: 2 }
]
